import "../../styles/@slug/single.scss";


window.addEventListener("DOMContentLoaded", () => {
    const main = document.getElementById('main');
    const title = main.querySelector('.wp-block-post-title');
    const maybeTitle = main.querySelector('.entry-content>h2:first-child');

    if (maybeTitle && title.innerText === maybeTitle?.innerText) {
        title.style.display = "none";
    }
})